import { WSAlert } from "@wingspanhq/fe-component-library";
import { SearchRowRequirementExpirationStatus } from "@wingspanhq/wingspan-api-sdk";
import { queriesPayeeRows } from "@query";
import { useXWingspanExpansion } from "../../../../shared/hooks/useXWingspanExpansion";
import { useGoToBulkReviewRequirements } from "../../../BulkReview/paths";
import { PayeeFilterRequirementStatus } from "./filters/types";

type Props = {};

export const AlertExpiringRequirements: React.FC<Props> = props => {
  const goToBulkReviewRequirements = useGoToBulkReviewRequirements();
  const xWingspanAccount = useXWingspanExpansion();

  const querySummary = queriesPayeeRows.searchPayeeRows.useQuery(
    {
      filter: {
        requirements_expirationStatus: {
          eq: SearchRowRequirementExpirationStatus.EXPIRING
        }
      },
      page: { size: 1 },
      xWingspanAccount
    },
    { select: list => list.pagination?.totalSize }
  );

  if (!querySummary.data || querySummary.data < 2) {
    return null;
  }

  return (
    <WSAlert
      theme="info"
      my="L"
      title="Multiple requirements expiring soon"
      icon="collection"
      action={{
        text: "View requirements",
        onClick: () => {
          goToBulkReviewRequirements({
            filter: {
              status: PayeeFilterRequirementStatus.Expiring
            }
          });
        }
      }}
    >
      Multiple requirements are expiring soon. Contractors have been reminded to
      renew their documents and the requirements are now awaiting contractor
      renewals.
    </WSAlert>
  );
};
